
// equal height
function setEqualHeight(selector) {
  const cards = document.querySelectorAll(selector);
 
  if (cards.length === 0) return;
 
  cards.forEach(card => {
    card.style.height = 'auto';
  });
 
  let maxHeight = 0;
  cards.forEach(card => {
    maxHeight = Math.max(maxHeight, card.offsetHeight);
  });
 
  cards.forEach(card => {
    card.style.height = maxHeight + 'px';
  });
}
 
function runEqualHeights() {
  setEqualHeight('.vizion-card-content');
  setEqualHeight('.our-product-main-card');
  setEqualHeight('.customer-review-desc');
  setEqualHeight('.why-taste-slider-content');
}
 
window.addEventListener('load', runEqualHeights);
window.addEventListener('resize', runEqualHeights);



 window.addEventListener('scroll', function () {
    const header = document.querySelector('.header-wrapper');
    if (window.scrollY > 50) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  });

var swiper = new Swiper(".mySwiper", {
  slidesPerView: 1, // default for <651px
  spaceBetween: 20,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  loop: true,
  breakpoints: {
    // when screen width is >= 651px
    651: {
      slidesPerView: 2
    }
  }
});


var swiper = new Swiper(".whytasteswiper", {
  spaceBetween: 30,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  autoplay: {
    delay: 3000, // 3000 milliseconds = 3 seconds
    disableOnInteraction: false, // optional: keeps autoplay running after interaction
  },
});


const cartDrawer = document.querySelector('cart-drawer');

if (cartDrawer) {
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.attributeName === 'class') {
        if (cartDrawer.classList.contains('active')) {
          document.documentElement.style.overflow = 'hidden';
        } else {
          document.documentElement.style.overflow = '';
        }
      }
    });
  });

  observer.observe(cartDrawer, { attributes: true });
}

// add class on html
$('.icon-hamburger').on('click', function() {
  $('html').addClass('hide-height');
});

$('.icon-close').on('click', function() {
  $('html').removeClass('hide-height');
});




window.addEventListener("DOMContentLoaded", () => {
  const cookingSection = document.querySelector('.cooking-for-you');
  if (!cookingSection) return;
  const cookingContent = document.querySelector('.cooking-content');
  const leftImg = document.querySelector('.cooking-left-img');
  const centerImg = document.querySelector('.cooking-center-img');
  const rightImg = document.querySelector('.cooking-right-wraper');
  const fakeContent = document.querySelector('.cooking-fake-content');

  // Select only the SVG paths within the .cooking-for-you section
  const paths = Array.from(cookingSection.querySelectorAll("path"));

  // Sort paths by x position
  paths.sort((a, b) => {
    const aBox = a.getBBox();
    const bBox = b.getBBox();
    return bBox.x - aBox.x;
  });

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Animate SVG paths
        paths.forEach((path, index) => {
          path.classList.add("svg-path");
          path.style.animationDelay = `${index * 0.10}s`;
        });

        // Show images at different intervals
        if (rightImg) setTimeout(() => rightImg.classList.add('show-img'), 100);
        if (centerImg) setTimeout(() => centerImg.classList.add('show-img'), 200);
        if (leftImg) setTimeout(() => leftImg.classList.add('show-img'), 300);

        // Show cooking content after 4 seconds
        setTimeout(() => {
          if (cookingContent) cookingContent.classList.add('show');
        }, 300);

        // Show fake content after 4.3 seconds
        setTimeout(() => {
          if (fakeContent) fakeContent.classList.add('show');
        }, 300);

        observer.disconnect();
      }
    });
  }, {
    threshold: 0.2
  });

  observer.observe(cookingSection);
});



// faq script
const buttons = document.querySelectorAll(".accordion-btn");
const groups = document.querySelectorAll(".accordion-group");

// Activate the second button and group by default
if (buttons.length >= 2 && groups.length > 0) {
  // Remove active class from all buttons
  buttons.forEach(btn => btn.classList.remove("active"));

  // Add active to second button
  buttons[1].classList.add("active");

  // Hide all groups
  groups.forEach(group => group.style.display = "none");

  // Show the group linked to the second button
  const targetId = buttons[1].getAttribute("data-target");
  const targetGroup = document.getElementById(targetId);
  if (targetGroup) {
    targetGroup.style.display = "block";
  }
}

// Button click to show correct group
buttons.forEach(button => {
  button.addEventListener("click", () => {
    const targetId = button.getAttribute("data-target");

    // Hide all groups
    groups.forEach(group => group.style.display = "none");

    // Remove active class from all buttons
    buttons.forEach(btn => btn.classList.remove("active"));

    // Show selected group and set active class
    const targetGroup = document.getElementById(targetId);
    if (targetGroup) {
      targetGroup.style.display = "block";
    }
    button.classList.add("active");
  });
});


// faq
document.querySelectorAll(".question h3, .question .icon").forEach(el => {
  el.addEventListener("click", (event) => {
    const question = event.target.closest(".question");
    const answer = question.nextElementSibling;
    const icon = question.querySelector(".icon");
    const group = question.closest(".accordion-group");

    // Close other answers in the same group
    group.querySelectorAll(".answer").forEach(a => {
      if (a !== answer) {
        a.style.maxHeight = null;
        a.classList.remove("open");
        a.previousElementSibling.querySelector(".icon").textContent = "+";
      }
    });

    // Toggle current answer
    if (answer.classList.contains("open")) {
      answer.style.maxHeight = null;
      answer.classList.remove("open");
      icon.textContent = "+";
    } else {
      answer.classList.add("open");
      answer.style.maxHeight = answer.scrollHeight + "px";
      icon.textContent = "−";
    }
  });
});





// Header active state
const current = new URL(location.href);
current.hash = current.search = "";
 
document
  .querySelectorAll(".header__menu-item, .quick-menu-area ul li a")
  .forEach((link) => {
    if (new URL(link.href, location.origin).href === current.href) {
      link.classList.add("custom-active");
    }
  });



// Tab Accordian
const tabButtons = {
  one: document.querySelector('.tab-btn-one'),
  two: document.querySelector('.tab-btn-two'),
  three: document.querySelector('.tab-btn-three')
};

const tabContents = {
  one: document.querySelector('.tab-one'),
  two: document.querySelector('.tab-two'),
  three: document.querySelector('.tab-three')
};

const allButtons = Object.values(tabButtons).filter(Boolean); // Filter out null buttons

// Apply border-radius based on visible buttons
if (allButtons.length === 1) {
  allButtons[0].style.borderTopLeftRadius = '40px';
  allButtons[0].style.borderTopRightRadius = '40px';
} else if (allButtons.length === 2) {
  allButtons[0].style.borderTopLeftRadius = '40px';
  allButtons[1].style.borderTopRightRadius = '40px';
}

// Hide all tab contents
function hideAllTabs() {
  Object.values(tabContents).forEach(tab => tab?.classList.remove('active'));
  allButtons.forEach(btn => btn.classList.remove('active-btn'));
}

// Show selected tab
function showTab(key) {
  hideAllTabs();
  tabContents[key]?.classList.add('active');
  tabButtons[key]?.classList.add('active-btn');
}

// Set up click events
if (tabButtons.one) tabButtons.one.addEventListener('click', () => showTab('one'));
if (tabButtons.two) tabButtons.two.addEventListener('click', () => showTab('two'));
if (tabButtons.three) tabButtons.three.addEventListener('click', () => showTab('three'));

// Apply initial active tab based on count
if (allButtons.length > 2 && tabButtons.two) {
  tabButtons.two.classList.add('active-btn');
  tabContents.two?.classList.add('active');
} else if (tabButtons.one) {
  tabButtons.one.classList.add('active-btn');
  tabContents.one?.classList.add('active');
}




// accordian
document.querySelectorAll('.detail-accordian-question').forEach(button => {
  button.addEventListener('click', (e) => {
    // Only toggle if the clicked element is the h3 or has the class 'detail-icon'
    if (e.target.tagName.toLowerCase() === 'h3' || e.target.classList.contains('detail-icon')) {
      const accordionItem = button.closest('.detail-accordion-item');
      accordionItem.classList.toggle('open-detail-faq');
    }
  });
});


// Hero headings render as accessible static text. The former letter-by-letter
// animation caused long headings to clip and remain partially invisible.
